export const toTitleCase = string => string.split(" ").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ")